import { Outlet } from 'react-router-dom';

import { GuardCoachInterview } from '@/features/coach-interview/GuardCoachInterview';

export const CoachInterviewLayout: React.FC = () => {
  return (
    <GuardCoachInterview>
      <Outlet />
    </GuardCoachInterview>
  );
};
